import { useEffect } from "react";
import { useShallow } from "zustand/shallow";

import { constants } from "@src/components/LinkChanger/constants";

import { useOfflineModeState } from "@src/states/offline_mode";
import { usePlayerState } from "@src/states/player";

import { player } from "@src/services/player";
import { DEFAULT_TRACK_ID } from "@src/services/player/constants";

import { dispatchEventToNative } from "@src/utils/dispatchEventToNative";

import "./style.less";

export function ErrorMessage() {
  // Determina a mensagem de erro
  let error = null;
  const [currentTrackObj, currentTrackId, onAir] = usePlayerState(
    useShallow((state) => [
      state.tracks[state.currentTrackId],
      state.currentTrackId,
      state.onAir,
    ]),
  );
  const status = currentTrackObj?.status;
  const isOnlinePlaying = currentTrackId === DEFAULT_TRACK_ID;

  const offlineModeColor = useOfflineModeState((state) => state.color);
  const clickPlay = (e: string): string => {
    if (offlineModeColor === "green") {
      e += ", dê o Play e use nosso modo offline";
    }
    return e;
  };

  if (!onAir && isOnlinePlaying) {
    error = clickPlay("Rádio temporariamente indisponível");
  } else if (status === "error") {
    error = player.getError();
    if (!error) {
      error = currentTrackObj?.statusText;
    }
  }

  if (error === "Offline track stuck in loadstart.") {
    error = clickPlay("Você está sem internet");
  }
  if (error === "NotAllowedError" || String(error).includes("PIPELINE_ERROR")) {
    // Autoplay falhou ou falha interna do pipeline de áudio do browser (ex: dispositivo BT desconectado)
    error = "Dê o Play para ouvir a rádio";
  }
  if (error === "NotSupportedError") {
    // Play falhou
    error = "Falha ao tocar áudio, aguarde alguns segundos";
  }

  let shouldTryAlternativeLink = String(error).includes("MEDIA_ELEMENT_ERROR");
  if (
    String(error).includes("DEMUXER_ERROR_COULD_NOT_OPEN") &&
    currentTrackObj?.url
  ) {
    // Sem conectividade com o URL do áudio
    error = `Falha ao baixar áudio do servidor: ${currentTrackObj.url}`;
    if (isOnlinePlaying) {
      shouldTryAlternativeLink = true;
    }
  }
  if (shouldTryAlternativeLink) {
    // Proxy falhou (https://stream.fabriccamultimidia.com/ ou https://stream.fabricca.pro/)
    error = `Falha ao tocar áudio, tente clicar no botão '${constants.linkText}'`;
  }

  useEffect(() => {
    if (shouldTryAlternativeLink) {
      dispatchEventToNative("change_link");
    }
  }, [shouldTryAlternativeLink]);

  if (!error) {
    return <></>;
  }
  return (
    <div className="ErrorMessage-component">
      <span>{error}</span>
    </div>
  );
}
